<template>
  <div style="border-top: 1px solid #e2e2e2; padding: 20px 0">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
    >
      <el-form-item
        label="服务费计算方式"
        prop="import_calc_service_cost_mode"
        :rules="[
          { required: true, message: '请选择服务费计算方式', trigger: 'blur' },
        ]"
      >
        <el-radio-group
          v-model="state.model.import_calc_service_cost_mode"
          size="large"
        >
          <el-radio-button label="以系统计算为准" :value="0">
            <el-tooltip
              class="box-item"
              effect="dark"
              content="该模式下，导入时员工服务费由系统根据员工所匹配的计算方式计算得出最终的服务费"
            >
              以系统计算为准
            </el-tooltip>
          </el-radio-button>
          <el-radio-button label="以本次导入为准" :value="1">
            <el-tooltip
              class="box-item"
              effect="dark"
              content="该模式下，导入时员工服务费以表格中填写值为准"
            >
              以本次导入为准
            </el-tooltip>
          </el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="表格文件(仅支持.xlsx文件)"
        prop="file"
        :rules="[
          { required: true, message: '请选择表格文件', trigger: 'blur' },
        ]"
      >
        <div
          style="
            display: flex;
            align-items: center;
            column-gap: 10px;
            width: 100%;
          "
        >
          <el-input
            v-model="state.fileName"
            size="large"
            placeholder="--请选择文件--"
            readonly
            style="flex: 1"
          ></el-input>
          <el-upload
            action="#"
            :show-file-list="false"
            ref="uploadDom"
            accept=".xlsx"
            :auto-upload="false"
            :on-change="onFileChange"
          >
            <template #default>
              <el-button type="primary" size="large"> 选择文件 </el-button>
            </template>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item
        label="子表"
        prop="import_sheet"
        :rules="[
          { required: true, message: '请选择要导入的子表', trigger: 'blur' },
        ]"
        v-if="state.sheetsData?.length > 0"
      >
        <el-select
          size="large"
          v-model="state.model.import_sheet"
          placeholder="请选择要导入的子表"
        >
          <el-option
            v-for="(item, index) in state.sheetsData"
            :key="item"
            :label="item"
            :value="index + 1"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <!-- <ul style="display: flex; align-items: center; justify-content: center">
      <text style="color: #a2a2a2">服务费计算方式：</text>
      <el-radio-group
        v-model="state.import_calc_service_cost_mode"
        size="large"
      >
        <el-radio-button label="以系统计算为准" :value="0">
          <el-tooltip
            class="box-item"
            effect="dark"
            content="该模式下，导入时员工服务费由系统根据员工所匹配的计算方式计算得出最终的服务费"
          >
            以系统计算为准
          </el-tooltip>
        </el-radio-button>
        <el-radio-button label="以本次导入为准" :value="1">
          <el-tooltip
            class="box-item"
            effect="dark"
            content="该模式下，导入时员工服务费以表格中填写值为准"
          >
            以本次导入为准
          </el-tooltip>
        </el-radio-button>
      </el-radio-group>
    </ul>
    <ul style="display: flex; align-items: center; margin-top: 10px">
      <text style="white-space: nowrap">文件：</text>
    </ul>
    <ul style="display: flex; align-items: center; margin-top: 10px">
      <text style="white-space: nowrap">子表：</text>
      <el-select
        size="large"
        v-model="state.import_sheet"
        placeholder="请选择要导入的子表"
      >
        <el-option
          v-for="(item, index) in state.sheetsData"
          :key="item"
          :label="item"
          :value="index"
        ></el-option>
      </el-select>
    </ul> -->
    <!-- <ul style="display: flex; align-items: center; margin-top: 10px">
      <text>子表序号：</text>
      <el-space wrap style="flex: 1">
        <el-tag
          v-for="item in 5"
          :key="item"
          :effect="item == state.import_sheet ? 'dark' : 'plain'"
          @click="state.import_sheet = item"
          style="cursor: pointer"
          size="large"
        >
          {{ item }}
        </el-tag>
        <el-tag
          :effect="state.import_sheet > 5 ? 'dark' : 'plain'"
          @click="state.import_sheet = 6"
          style="cursor: pointer"
          size="large"
        >
          其他
        </el-tag>
        <el-input-number
          v-model="state.import_sheet"
          :controls="false"
          class="number-input-left"
          :precision="0"
          style="width: 100px"
          ref="numDom"
          @focus="$onFocus"
        ></el-input-number>
      </el-space>
    </ul> -->
  </div>
  <div style="display: flex; align-items: center; justify-content: center">
    <el-button type="success" @click="onSubmitImport">确定导入</el-button>
    <el-button type="warning" @click="onDownLoad">模板下载</el-button>
  </div>
</template>

<script>
import { onMounted, reactive, getCurrentInstance, ref } from "vue";
import {
  payrollemployee_download,
  payrollemployee_import,
} from "@/http/payrollemployee";
import { ElMessage, ElMessageBox } from "element-plus";
import * as XLSX from "xlsx";
export default {
  props: {
    payroll_id: Number,
    customer_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const { proxy } = getCurrentInstance();
    const state = reactive({
      model: {
        import_calc_service_cost_mode: 1,
      },
    });
    onMounted(() => {});

    //选择文件
    const onFileChange = (file) => {
      state.fileName = file.name;
      state.model.file = file.raw;

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        state.sheetsData = workbook.SheetNames;
        if (state.sheetsData?.length > 0) state.model.import_sheet = 1;
      };
      reader.readAsArrayBuffer(file.raw);
    };

    const onSubmitImport = () => {
      // if (
      //   state.import_calc_service_cost_mode == undefined ||
      //   state.import_calc_service_cost_mode == null
      // ) {
      //   ElMessage({
      //     type: "warning",
      //     message: "请选择服务费计算方式",
      //     grouping: true,
      //   });
      //   return false;
      // }

      // if (!state.selectFile?.raw) {
      //   ElMessage({
      //     type: "warning",
      //     message: "请选择文件！",
      //     grouping: true,
      //   });
      //   return false;
      // }

      formDom.value.validate((valid) => {
        if (valid) {
          const formData = new FormData();
          //把接口需要的参数带进去
          formData.append("payroll_id", props.payroll_id);
          formData.append("import_sheet", state.model.import_sheet);
          formData.append(
            "import_calc_service_cost_mode",
            state.model.import_calc_service_cost_mode,
          );
          formData.append("file", state.model.file);
          payrollemployee_import(formData)
            .then((res) => {
              if (res.status == 200) {
                if (res.data?.data?.error_count > 0) {
                  if (res.data?.data?.is_have_exception) {
                    ElMessageBox.confirm(res.data?.msg, "导入结果通知", {
                      dangerouslyUseHTMLString: true,
                      confirmButtonText: "去处理异常",
                      cancelButtonText: "复制",
                      distinguishCancelAndClose: true,
                      type: "error",
                      beforeClose: (action, ins, done) => {
                        if (action == "confirm") {
                          emit("success", true);
                          done();
                        } else if (action == "cancel") {
                          proxy.$onCopy(res.data?.msg?.replace(/<br>/g, ""));
                        } else {
                          emit("success");
                          done();
                        }
                      },
                    });
                  } else {
                    ElMessageBox.confirm(`${res.data?.msg}`, "导入提示", {
                      confirmButtonText: "关闭",
                      cancelButtonText: "复制异常信息",
                      confirmButtonClass: "el-button--danger",
                      distinguishCancelAndClose: true,
                      type: "error",
                      beforeClose: (action, ins, done) => {
                        if (action == "confirm") {
                          emit("success");
                          done();
                        } else if (action == "cancel") {
                          proxy.$onCopy(res.data?.msg);
                        } else {
                          emit("success");
                          done();
                        }
                      },
                    });
                  }
                } else {
                  ElMessage.success(res.data?.msg);
                  emit("success");
                }
              }
            })
            .catch((err) => {
              ElMessageBox.confirm(`${err.data.msg}`, "导入异常", {
                confirmButtonText: "关闭",
                cancelButtonText: "复制异常信息",
                confirmButtonClass: "el-button--danger",
                distinguishCancelAndClose: true,
                type: "error",
                beforeClose: (action, ins, done) => {
                  if (action == "confirm") {
                    done();
                  } else if (action == "cancel") {
                    proxy.$onCopy(err.data.msg);
                  } else {
                    done();
                  }
                },
              });
            });
        }
      });
    };

    const onDownLoad = () => {
      payrollemployee_download(props.payroll_id)
        .then((res) => {
          if (res.status == 200) {
            let fileName = decodeURI(
              res.headers["content-disposition"].split("=")[1],
            );

            //通过后台返回 的word文件流设置文件名并下载
            var blob = new Blob([res.data], {
              type: res.data.type,
            });
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
          }
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      onFileChange,
      onSubmitImport,
      onDownLoad,
      formDom,
    };
  },
};
</script>
<style scoped></style>
